import { DateTimePicker } from '@mantine/dates';
import { DatePickerInputConfigDefaultProps } from '../DatePickerInput/DatePickerInput.config';

export const DateTimePickerConfig = DateTimePicker.extend({
  defaultProps: DatePickerInputConfigDefaultProps,
});
